import { render } from "./BaseForm.vue?vue&type=template&id=5990f237"
const script = {}

import "./BaseForm.vue?vue&type=style&index=0&id=5990f237&lang=css"

import exportComponent from "/workspaces/e-commerce-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__